import React, { useState } from 'react';
import { Form, Modal, Input, Tooltip, Upload, Icon, Checkbox } from 'antd';
import { setStatusDoneAndGetRequest } from '../../../requests/setStatusDoneAndGetRequest';

const { TextArea } = Input;

const RequestComplete = ({
  form,
  visible,
  onCancel,
  afterSubmit,
  requestId,
}) => {
  const [confirmLoading, setConfirmLoading] = useState(false);

  const { getFieldDecorator, validateFields, resetFields } = form;

  const normFile = (e) => {
    return Array.isArray(e) ? e : e?.fileList || [];
  };

  const handleCancel = () => {
    if (typeof onCancel === 'function') {
      onCancel();
    }
    resetFields();
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    validateFields(async (err, formValues) => {
      if (!err) {
        setConfirmLoading(true);

        const updatedRequest = await setStatusDoneAndGetRequest({
          requestId,
          data: formValues,
        });

        setConfirmLoading(false);

        if (typeof afterSubmit === 'function') {
          afterSubmit({
            updatedRequest:
              updatedRequest?.length === 1 ? updatedRequest[0] : null,
            formValues,
          });
        }

        resetFields();
      }
    });
  };

  return (
    <Modal
      title='Изменить статус заявки на "Выполнено"'
      visible={visible}
      onCancel={handleCancel}
      onOk={handleSubmit}
      destroyOnClose
      confirmLoading={confirmLoading}
    >
      <Form>
        <Form.Item label="Комментарий" style={{ marginBottom: 0 }}>
          {getFieldDecorator('note', { initialValue: '' })(
            <TextArea placeholder="Введите комментарий" />
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('availableForClient', {
            valuePropName: 'checked',
            initialValue: false,
          })(<Checkbox>Показывать собственнику</Checkbox>)}
        </Form.Item>
        <Form.Item label="Вложения">
          {getFieldDecorator('files', {
            valuePropName: 'fileList',
            getValueFromEvent: normFile,
            initialValue: [],
          })(
            <Upload.Dragger name="files" multiple beforeUpload={() => false}>
              <Tooltip title="Чтобы прикрепить файл, перетащите его сюда, или нажмите чтобы выбрать">
                <Icon type="file-add" theme="outlined" />
              </Tooltip>
            </Upload.Dragger>
          )}
        </Form.Item>
      </Form>
    </Modal>
  );
};

const RequestCompleteModal = Form.create({ name: 'request_complete' })(
  RequestComplete
);

export default RequestCompleteModal;
